import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Clock } from 'lucide-react';
import { HelpArticle, stripMarkdown } from '@/services/helpService';

interface ArticleListItemProps {
  article: HelpArticle;
}

export function ArticleListItem({ article }: ArticleListItemProps) {
  return (
    <Link
      to={`/help/${article.category}/${article.slug}`}
      className="group flex items-start justify-between py-4 first:pt-0 last:pb-0"
    >
      <div className="min-w-0 flex-1">
        <h3 className="font-medium text-gray-900 group-hover:text-violet-600 transition-colors">
          {stripMarkdown(article.title)}
        </h3>
        {article.excerpt && (
          <p className="text-sm text-gray-500 mt-1 line-clamp-2">
            {stripMarkdown(article.excerpt)}
          </p>
        )}
        {article.updated_at && (
          <div className="flex items-center gap-1 mt-2 text-xs text-gray-400">
            <Clock className="w-3 h-3" />
            <span>
              Updated{' '}
              {new Date(article.updated_at).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })}
            </span>
          </div>
        )}
      </div>
      <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-violet-600 flex-shrink-0 ml-4 transition-colors" />
    </Link>
  );
}

interface ArticleCardProps {
  article: HelpArticle;
}

export function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/help/${article.category}/${article.slug}`}
      className="group block p-4 rounded-xl border border-gray-200 bg-white hover:border-violet-300 hover:shadow-sm transition-all"
    >
      <h3 className="font-medium text-gray-900 group-hover:text-violet-600 transition-colors mb-2">
        {stripMarkdown(article.title)}
      </h3>
      {article.excerpt && (
        <p className="text-sm text-gray-500 line-clamp-2">
          {stripMarkdown(article.excerpt)}
        </p>
      )}
    </Link>
  );
}
